// import React from 'react'

// interface INewsDeep{
//     newsImage:string,
//     isDark:boolean,
//     date?:string,
//     details?:string,
//     category?:string,
//     title:string,
//     small?:boolean
// }

// const NewsDeep:React.FC<INewsDeep> = ({newsImage, isDark, date, details, category, title, small}) => {
//   return (
//     <div className={`${small ? 'h-[200px]' : 'h-[400px]'} relative after:absolute after:top-0 after:left-0 after:w-full after:h-full after:bg-gradient-to-b after:from-transparent after:to-black`}>
//           <img className='h-full object-cover' src={newsImage} alt="politics" />
//           <div className={`text-white z-30 absolute ${small ? 'bottom-5 left-5':'bottom-10 left-10'}`}>
//             {date && <h2 className={`${small ? 'text-xs' : 'text-sm'}`}>{category} / {date}</h2>}
//             <h1 className={`${small ? 'sm:text-xl text-lg' : 'sm:text-3xl text-xl'} font-semibold`}>
//               {title}
//             </h1>
//             <p className={`${small ? 'text-xs' : 'text-sm'}`}>
//               {details}
//             </p>
//           </div>
//         </div>
//   )
// }

// export default NewsDeep

// ---- version -----
import React from "react";
import { handleTitleClick } from "../../../pages/news/data";

interface INewsDeep {
  newsImage: string;
  isDark: boolean;
  date?: string;
  details?: string;
  category?: string;
  title: string;
  small?: boolean;
  slug?: string;
}

const NewsDeep: React.FC<INewsDeep> = ({
  newsImage,
  isDark,
  date,
  details,
  category,
  title,
  small,
  slug,
}) => {
  return (
    <div
      className={`relative rounded-lg overflow-hidden shadow-md ${
        small ? "h-[200px]" : "h-[400px]"
      } ${isDark ? "bg-darkBg" : "bg-gray-200"}`}
    >
      <img
        className="w-full h-full object-cover"
        src={newsImage}
        alt="News featured"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent" />
      <div
        className={`absolute text-white p-4 ${
          small ? "bottom-2 left-2 right-2" : "bottom-4 left-4 right-4"
        }`}
      >
        {date && (
          <p className={`text-xs text-gray-300 ${small ? "" : "sm:text-sm"}`}>
            {category} • {date}
          </p>
        )}
        <h1
          onClick={() => {
            handleTitleClick(slug);
          }}
          className={`mt-1 cursor-pointer font-medium line-clamp-2 ${
            small ? "text-base sm:text-lg" : "text-lg sm:text-2xl"
          }`}
        >
          {title}
        </h1>
        {details && (
          <p
            className={`mt-1 line-clamp-2 ${
              small ? "text-xs" : "text-sm sm:text-base"
            }`}
          >
            {details}
          </p>
        )}
      </div>
    </div>
  );
};

export default NewsDeep;
